import type { HomeHeroSmallImageData } from "@/lib/homepage";

type HeroACSmallimageProps = {
  data?: HomeHeroSmallImageData;
};

const DEFAULT_DATA: Required<HomeHeroSmallImageData> = {
  imageUrl: "https://api.builder.io/api/v1/image/assets/TEMP/89d6d416a09b16c40ed045dd99954fa2217a0e95?width=500",
  imageAlt: "OnPlexus Partner Program",
  heading: "Unlock New Solutions & Revenue Streams",
  description:
    "Join our Partner Program and gain access to our powerful Currency Orchestration Platform and the expertise you need to succeed in the evolving world of global finance.",
  ctaLabel: "Let's get started",
  ctaUrl: "#",
};

export default function HeroACSmallimage({ data }: HeroACSmallimageProps) {
  const resolved = {
    imageUrl: data?.imageUrl || DEFAULT_DATA.imageUrl,
    imageAlt: data?.imageAlt || DEFAULT_DATA.imageAlt,
    heading: data?.heading || DEFAULT_DATA.heading,
    description: data?.description || DEFAULT_DATA.description,
    ctaLabel: data?.ctaLabel || DEFAULT_DATA.ctaLabel,
    ctaUrl: data?.ctaUrl || DEFAULT_DATA.ctaUrl,
  } as const;

  return (
    <section className="relative flex flex-col items-center bg-onplexus-dark w-full pt-[120px] pb-12">
      <div className="flex flex-col items-center gap-8 w-full px-4 sm:px-6 md:px-8 lg:px-8 xl:px-8">
        {/* Logo/Image */}
        <div className="w-[250px] h-[250px] flex-shrink-0">
          <img
            src={resolved.imageUrl}
            alt={resolved.imageAlt}
            className="w-full h-full object-contain"
          />
        </div>

        {/* Content Container */}
        <div className="flex flex-col items-center gap-4 w-full max-w-[900px] pb-6 sm:pb-8 md:pb-12">
          {/* Title */}
          <h1 className="text-white text-center font-normal text-[42px] leading-[48px] w-full px-4 sm:px-8">
            {resolved.heading}
          </h1>

          {/* Description Container */}
          <div className="flex flex-col items-center w-full max-w-[550px] pt-2 pb-8 sm:pb-12 px-0">
            <p className="text-white/70 text-center text-lg leading-[26px] font-normal w-full">
              {resolved.description}
            </p>
          </div>

          {/* CTA Button */}
          {resolved.ctaUrl ? (
            <a
              href={resolved.ctaUrl}
              className="flex h-[45px] px-6 justify-center items-center gap-1.5 bg-onplexus-gold text-onplexus-dark hover:bg-onplexus-gold-bright rounded-xl pl-6 pr-4 py-3 h-12 font-semibold text-lg cursor-pointer no-underline"
            >
              <span>{resolved.ctaLabel}</span>
              <span className="onplexus-icon text-5xl pt-0.5">→</span>
            </a>
          ) : null}
        </div>
      </div>
    </section>
  );
}
